import ContentBox from './ContentBox';

export default ContentBox;
